import { TieredPriceModal } from '../../input/tieredPricing/TieredPriceModal';
import { useCallback, useMemo, useState } from 'react';
import { useProperty } from './useProperty';
import { useObjectTypeId } from './useObjectTypeId';
import { useAdditionalPropertyValues } from './useAdditionalPropertyValues';
import { useHomeCurrency } from './useHomeCurrency';
import { getEffectiveTieredPriceCurrencyCode } from '../../utils/currency';
import { PRODUCT_TYPE_ID, LINE_ITEM_TYPE_ID } from 'customer-data-objects/constants/ObjectTypeIds';
import { jsx as _jsx } from "react/jsx-runtime";
export const useTieredPricingModal = () => {
  const objectTypeId = useObjectTypeId();
  const property = useProperty();
  const [showTiersModal, setShowTiersModal] = useState(false);
  const {
    data: additionalValues
  } = useAdditionalPropertyValues({
    lineItemCurrencyCode: 'hs_line_item_currency_code',
    pricingModel: 'hs_pricing_model',
    tiersPrices: 'hs_tier_prices',
    tiersRanges: 'hs_tier_ranges'
  });
  const {
    data: homeCurrencyCode
  } = useHomeCurrency();
  const openModal = useCallback(() => {
    setShowTiersModal(true);
  }, []);
  const closeModal = useCallback(() => {
    setShowTiersModal(false);
  }, []);
  const effectiveCurrencyCode = useMemo(() => {
    return getEffectiveTieredPriceCurrencyCode(objectTypeId, property, homeCurrencyCode, additionalValues === null || additionalValues === void 0 ? void 0 : additionalValues.lineItemCurrencyCode);
  }, [objectTypeId, property, additionalValues, homeCurrencyCode]);

  // Disable the button when:
  // - the pricing model is not set
  // - hs_tier_prices or hs_tier_ranges are not set (invalid state for modal)
  // - hs_tier_prices or hs_tier_ranges are empty strings (invalid state for modal)
  // - Object Type is Product
  //    - and both effectiveCurrencyCode and homeCurrencyCode are undefined or empty string
  // - Object Type is Line Item
  //    - and effectiveCurrencyCode is undefined (required for TieredPriceModal)
  // There should already be validations on the BE to prevent hs_tier_prices or hs_tier_ranges from being undefined if the pricing model is one of the tiered pricing models.
  const isViewTiersButtonDisabled = (additionalValues === null || additionalValues === void 0 ? void 0 : additionalValues.pricingModel) == null || (additionalValues === null || additionalValues === void 0 ? void 0 : additionalValues.pricingModel) === '' || (additionalValues === null || additionalValues === void 0 ? void 0 : additionalValues.tiersPrices) == null || (additionalValues === null || additionalValues === void 0 ? void 0 : additionalValues.tiersPrices) === '' || (additionalValues === null || additionalValues === void 0 ? void 0 : additionalValues.tiersRanges) == null || (additionalValues === null || additionalValues === void 0 ? void 0 : additionalValues.tiersRanges) === '' || objectTypeId === PRODUCT_TYPE_ID && (effectiveCurrencyCode === undefined || effectiveCurrencyCode === '') && homeCurrencyCode === undefined || objectTypeId === LINE_ITEM_TYPE_ID && (effectiveCurrencyCode === undefined || effectiveCurrencyCode === '');
  const modal = useMemo(() => {
    if (showTiersModal) {
      return /*#__PURE__*/_jsx(TieredPriceModal, {
        onSave: closeModal,
        onClose: closeModal
      });
    }
    return null;
  }, [showTiersModal, closeModal]);
  return {
    openModal,
    closeModal,
    canOpenModal: !isViewTiersButtonDisabled,
    modal
  };
};